import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import DemoPlayApp from "./Demo/DemoPlayApp";
import { isdemo } from "./components/urlParams";
import ScratchCoin from "./pages/ScratchCoin";
const rootElement = document.getElementById("root") as HTMLElement | null;
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as Element); // Cast to Element here
  root.render(<BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />    
      <Route path="/bingoDemo" element={<DemoPlayApp />} />
      <Route path="/scratch-coin" element={<ScratchCoin />} />
    </Routes>
  </BrowserRouter>,);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
  